import React from "react";
import { cn } from "@/design-system/components/react/utils";

type Variant = "rows" | "card" | "inline";

// HTMLElement (not HTMLDivElement) because the inline variant renders a <span>.
interface GhostProps extends React.HTMLAttributes<HTMLElement> {
  variant?: Variant;
  count?: number;
}

// One placeholder primitive. Static low-contrast bars at real content
// geometry — NO shimmer (shimmer is itself an AI-template tell), NO spinner.
export const Ghost: React.FC<GhostProps> = ({
  variant = "rows",
  count = 6,
  className,
  ...rest
}) => {
  if (variant === "card") {
    return (
      <div
        data-ghost-variant="card"
        className={cn("h-full w-full rounded-xs bg-surface border border-border", className)}
        {...rest}
      />
    );
  }
  if (variant === "inline") {
    return (
      <span
        data-ghost-variant="inline"
        className={cn("inline-block h-3 w-16 rounded-xs bg-surface-2 align-middle", className)}
        {...rest}
      />
    );
  }
  return (
    <div data-ghost-variant="rows" className={cn("w-full space-y-2", className)} {...rest}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          data-ghost-row
          className="h-9 w-full rounded-xs bg-surface border border-border"
        />
      ))}
    </div>
  );
};
